import React from 'react'

export default (props) => (
    <span className="title-element align-middle">You're chatting as <span className="user-info-name">{props.user.name}</span></span>
)



// WEBPACK FOOTER //
// ./src/components/user_info_box.js